import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
// import { toast } from "react-toastify";
import Button from "../../../components/Button/Button";
import { FaSave, FaTimes } from "react-icons/fa";

const defaultForm = () => ({
  title: "",
  description: "",
  priority: "Medium",
});

const isDescriptionEmpty = (value) => !value || !value.trim();

export default function AddRequestModal({ isOpen, onClose, refreshList }) {
  const ASSO_ID = process.env.REACT_APP_ASSO_ID;

  const [form, setForm] = useState(defaultForm());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) setForm(defaultForm());
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!form.title.trim()) {
        // toast.warn("Le titre est requis.");
        return;
      }

      if (isDescriptionEmpty(form.description)) {
        // toast.warn("La description est requise.");
        return;
      }

      setLoading(true);

      try {
        const payload = {
          association_id: ASSO_ID,
          title: form.title.trim(),
          description: form.description.trim(),
          priority: form.priority,
          status: "Pending",
        };

        await axios.post(
          "https://api.monappliclub.com/api/requests/addRequest",
          payload,
        );

        // toast.success("Requête ajoutée avec succès !");
        onClose?.();
      } catch (error) {
        console.error("Erreur lors de l'ajout de la requête :", error);
        // toast.error("Erreur lors de l'ajout de la requête.");
      } finally {
        setLoading(false);
      }
    },
    [ASSO_ID, form, onClose, refreshList],
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden
      />

      <div
        className="relative w-full max-w-3xl overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-slate-200/70 dark:bg-slate-900 dark:ring-slate-700/70"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500 px-5 py-4">
          <h3 className="text-center text-lg font-bold uppercase text-white sm:text-xl">
            Ajouter une requête
          </h3>
          <p className="mt-1 text-center text-xs text-white/90">
            Décrivez précisément le besoin, le contexte, les étapes pour
            reproduire et le niveau de priorité.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 p-5 sm:p-6">
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-800 dark:text-slate-100">
              Titre
            </label>
            <input
              type="text"
              value={form.title}
              onChange={handleChange("title")}
              placeholder="Ex : Bouton 'Exporter' sur la page Inventaire"
              className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-slate-900 focus:outline-none focus:ring-2 focus:ring-violet-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-800 dark:text-slate-100">
              Description
            </label>
            <textarea
              value={form.description}
              onChange={handleChange("description")}
              placeholder="Décrivez la demande en détail : contexte, comportement observé, comportement attendu, étapes pour reproduire, navigateur/appareil, etc."
              rows={10}
              className="w-full resize-y rounded-xl border border-slate-300 bg-white px-3 py-3 text-sm leading-6 text-slate-900 focus:outline-none focus:ring-2 focus:ring-violet-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
              required
            />
            <p className="mt-1 text-[11px] text-slate-500 dark:text-slate-400">
              Astuce : indiquez les étapes exactes pour reproduire un bug et le
              support utilisé.
            </p>
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-800 dark:text-slate-100">
              Priorité
            </label>
            <select
              value={form.priority}
              onChange={handleChange("priority")}
              className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-slate-900 focus:outline-none focus:ring-2 focus:ring-violet-400 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
            >
              <option value="High">Urgent</option>
              <option value="Medium">Moyenne</option>
              <option value="Low">Basse</option>
            </select>
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <Button
              text="Annuler"
              icon={FaTimes}
              onClick={onClose}
              type="button"
              className="!rounded-xl !bg-slate-100 !text-slate-800 gap-2 hover:!bg-slate-200 dark:!bg-slate-800 dark:!text-slate-100 dark:hover:!bg-slate-700"
              disabled={loading}
            />
            <Button
              text={loading ? "En cours…" : "Ajouter"}
              icon={FaSave}
              type="submit"
              className={`!rounded-xl gap-2 ${
                loading ? "pointer-events-none opacity-60" : ""
              }`}
            />
          </div>
        </form>
      </div>
    </div>
  );
}
